import cx from 'classnames';
import { throttle } from 'lodash';
import { MEDIA_IS_READY } from 'config';
import reactHtmlParser from 'react-html-parser';
import { getYTId } from 'helpers';
import styled from 'styled-components';
import React from 'react';
import YouTube from 'react-youtube';
import styles from './reel.css';

const reel = {
  type: 'reel',
  title: 'viral showreal',
  colors: { title: '#fff', tile: '#fff' },
  video: {
    youtube: 'https://www.youtube.com/watch?v=d95aojA1slU',
    mobile: {
      src: '/upload/files/f3/f32e891da795af3abf1f420a9818c26e.mp4',
    },
    desktop: {
      src: '/upload/files/f3/f32e891da795af3abf1f420a9818c26e.mp4',
    },
  },
};

const PreviewWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: opacity 0.3s ease;
  z-index: -1;
  background-size: cover;
  background-position: center;

  @media (min-width: 1280px) {
    background-image: none;
  }
`;

const Wrapper = styled.div``;

const opts = {
  height: '390',
  width: '640',
  playerVars: {
    autoplay: 0,
    modestBranding: 1,
    controls: 1,
    fs: 0,
    rel: 0,
    showinfo: 0,
  },
};
class Reel extends React.Component {
  state = {
    player: null,
    isPlaying: false,
  };

  componentDidMount() {
    this.manageVideoLoadingOnStart();
  }

  componentWillReceiveProps(nextProps) {
    const { active, pageReady } = nextProps;
    if (pageReady && pageReady !== this.props.pageReady) {
      this.videoElement.play();
    }
    if (this.props.active === active) return;

    if (active) {
      this.onPlayVideo();
    } else {
      this.onPauseVideo();
    }
  }

  onReady = (e) => {
    this.setState(
      () => ({
        player: e.target,
      }),
      () => {
        if (this.state.isPlaying) {
          e.target.playVideo();
        }
      },
    );
  };

  onPlayVideo = () => {
    this.setState({ isPlaying: true });
    this.state.player && this.state.player.playVideo();
  };
  onPauseVideo = () => {
    this.state.player && this.state.player.pauseVideo();
  };

  onVideoTimeUpdate = (e) => {
    e.persist();
    if (!e.target) {
      return;
    }
    const { target: { currentTime, duration } } = e;
    if (duration - currentTime < 0.3) {
      this.videoElement.currentTime = 0;
    }
  };
  clickHandler = () => {
    // play video
    this.props.clickHandler();
  };

  manageVideoLoadingOnStart = () => {
    if (this.videoElement.readyState === MEDIA_IS_READY) {
      this.props.loadCb();
    }
  };

  render() {
    const {
      title, colors, active, video,
    } = this.props;
    const embedSrc = getYTId(video.youtube);
    return (
      <Wrapper
        tabIndex={0}
        className={cx(styles.root, active && styles.active)}
        onClick={this.clickHandler}
      >
        <PreviewWrapper className={styles.bgvideoWrapper}>
          <video
            ref={videoElement => (this.videoElement = videoElement)}
            className={styles.bgvideoDesktop}
            onCanPlay={this.manageVideoLoadingOnStart}
            onPause={this.localVideoPauseHandler}
            onTimeUpdate={this.onVideoTimeUpdate}
            preload="auto"
            autoPlay
            loop
            muted
            playsInline
          >
            {/* <source
              src="https://staging.coverr.co/s3/mp4/Renovation.mp4"
              type="video/mp4"
            /> */}
            <source src={video.desktop.src} type="video/mp4" />
          </video>
        </PreviewWrapper>
        <div className={styles.titleWrapper}>
          <h2
            style={{
              color: colors.title,
            }}
            className={styles.title}
          >
            {reactHtmlParser(title)}
          </h2>
          <div
            style={{
              backgroundColor: colors.tile,
            }}
            className={styles.bar}
          />
        </div>
        <YouTube
          onReady={this.onReady}
          className={styles.video}
          videoId={embedSrc}
          opts={opts}
        />
      </Wrapper>
    );
  }
}

Reel.defaultProps = {
  href: '',
  img: '',
  title: '',
  colors: {},
  clickHandler: () => {},
  active: false,
  video: {
    src: '',
    youtube: '',
    poster: {
      mobile: '',
    },
  },
};

export default Reel;



// WEBPACK FOOTER //
// ./src/components/modules/Reel/Reel.js